export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13931.a371a990.jpg";